import type { Tone } from '@/types/domain';

export const statusTone: Record<string, Tone> = {
  ACTIVE: 'green', VERIFIED: 'green', APPROVED: 'green', CHECKED: 'green', ACKNOWLEDGED: 'green', SETTLED: 'green',
  SUBMITTED: 'blue', IN_PROGRESS: 'blue', SENT: 'blue', UPLOADED: 'blue',
  PENDING_APPROVAL: 'amber', PENDING: 'amber',
  ON_HOLD: 'orange', RETURNED: 'orange', EXPIRED: 'orange',
  REJECTED: 'red', FAILED: 'red', MISMATCHED: 'red',
  BLOCKED: 'dark', CANCELLED: 'dark',
  DRAFT: 'grey', NOT_SYNCED: 'grey',
};

export const humanize = (value: string) => value.toLowerCase().split('_').map((word) => word[0].toUpperCase() + word.slice(1)).join(' ');
